import React, { ReactNode } from 'react'
import styles from './FormLayout.module.sass'

interface Props {
  className?: string
  children?: ReactNode
}

const FormLayout = ({ className = '', children }: Props) => (
  <div className={`${styles.root} ${className}`}>{children}</div>
)

export default FormLayout
